/**
 * GW-9113: Browsers vary in how they format the `TypeError` thrown on a network/CORS
 * failure. Chrome/Firefox historically throw the bare `"Failed to fetch"`; newer/headless
 * Chrome (observed: HeadlessChrome 148.0.0) appends the failing URL —
 * `"Failed to fetch (data.dev.generalwisdom.com)"`. An exact-equality check (`=== 'Failed
 * to fetch'`) misses that URL-suffixed variant, letting the `TypeError` escape uncaught and
 * reproduce the GW-8963 symptom (unhandled rejection to Sentry) via a message format
 * GW-8963's guard never covered.
 *
 * Match on prefix instead of exact equality so every browser variant that starts with
 * `"Failed to fetch"` is classified as a benign network error.
 *
 * Single source of truth for this classification — `BaseApiClient.fetchWithNetworkGuard`
 * and `organizationSlice`'s `fetchUserOrganizations` catch block both delegate here instead
 * of duplicating the string check.
 */
export function isFailedToFetchMessage(message: string): boolean {
  return message.startsWith('Failed to fetch');
}
